/**
 * Copyright (c) 2021 - 2022, Kodit Doo
 * Created by kodit-marko on 12/29/22
 */

import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {SelectItem} from 'primeng/api';
import {PdvEvidencijeClient, PdvOpseg, PdvPeriod} from '@kodit/core/data-api';
import {FormControl} from "@angular/forms";
import {PdvEvidencijaService} from "../../pdv-evidencija.service";

@Component({
  selector: 'kodit-pdv-opseg-dropdown',
  templateUrl: './pdv-opseg-dropdown.html',
  styleUrls: ['./pdv-opseg-dropdown.scss'],
})
export class PdvOpsegDropdownComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription;

  /** Props */
  items: SelectItem[];
  pdvOpsegCtrl: FormControl;

  /** I/O */
  @Input() formCtrlId: string;
  @Input() parentCtrl: string;
  @Input() periodValue!: PdvPeriod;
  @Input() shouldDisable: boolean = false;

  constructor(
    private _client: PdvEvidencijeClient,
    private _service: PdvEvidencijaService
  ) {
    this._subs = new Subscription();
    this.items = [];
    this.formCtrlId = 'pdv-opseg-dropdown';
    this.parentCtrl = 'body';
    this.pdvOpsegCtrl = new FormControl();
  }

  ngOnInit() {
    const pdvOpseg =
      this.periodValue > PdvPeriod.DECEMBAR
        ? PdvOpseg.KVARTALNO
        : PdvOpseg.MESECNO;

    this.pdvOpsegCtrl = new FormControl(pdvOpseg);

    this._load();
    this._subs.add(
      this.pdvOpsegCtrl.valueChanges.subscribe((res) => {
        this._service.setOpseg = res;
      })
    );
  }

  private _load() {
    this._subs.add(
      this._client.getPdvOpsegDropdown().subscribe((res) => {
        if (!res.succeeded) {
          return;
        }
        this.items = res.data!.responseList!.map((x) => ({
          value: x.opseg,
          label: x.opsegStr,
          title: x.opis,
        }));
      })
    );
  }

  ngOnDestroy(): void {
    this._service.resetOpseg();
    this._subs.unsubscribe();
  }
}
